// extracted by mini-css-extract-plugin
module.exports = {"full_price":"ProductPrice_full_price__WRY4P","strikethrough_dollars":"ProductPrice_strikethrough_dollars__IZIzQ"};